import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, Transition as _Transition, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "you-skeleton"
};
const _hoisted_2 = { key: 0 };
const _hoisted_3 = ["src"];
const _hoisted_4 = {
    key: 2,
    style: { "height": "60px" }
};
import { ref, computed, getCurrentInstance, onMounted } from 'vue';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useApi } from '@/composables/useApi';
import { getHttpInstance, getApiConfig } from '@/composables/useApi';
import { useProducts } from '@/composables/useProducts';
import { useCustomer } from '@/composables/useCustomer';
import { useContent } from '@/composables/useContent';
import { useVouchers } from '@/composables/useVouchers';
import { useDocuments } from '@/composables/useDocuments';
import { useEmployer } from '@/composables/useEmployer';
import InfoPanel from './elements/InfoPanel.vue';
import ScrollThumbBlock from './elements/ScrollThumbBlock.vue';
import AdButton from './elements/AdButton.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import DrawerPanel from './elements/DrawerPanel.vue';
import WhatsAppEnableDrawer from './elements/WhatsAppEnableDrawer.vue';
import DocumentsInfoPanel from './elements/DocumentsInfoPanel.vue';
import MGMInfoPanel from './elements/MGMInfoPanel.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'YouPage',
    setup(__props) {
        const state = useAppState();
        useAuth();
        const api = useApi();
        const { getCustomer, getEmployer } = useCustomer();
        const { getProducts } = useProducts();
        const { getLatestFinancialFitness } = useContent();
        const { getBlueLightCard } = useVouchers();
        const { getDocuments } = useDocuments();
        const instance = getCurrentInstance();
        const cookies = instance?.appContext.config.globalProperties.$cookies;
        const blueLight = ref(null);
        const showPoints = ref(false);
        const whatsAppEnableDrawer = ref(null);
        const documentCategoryCount = computed(() => {
            if (!state.documents)
                return 0;
            const categories = new Set();
            state.documents.forEach((doc) => {
                const path = doc.sysoDocumentType?.path;
                if (path) {
                    const category = path.split(' > ')[1];
                    if (category)
                        categories.add(category);
                }
            });
            return categories.size || 1;
        });
        const { isMoneyGuided: showPayslips } = useEmployer();
        const payslipCount = computed(() => {
            if (!state.documents)
                return 0;
            return state.documents.filter((doc) => {
                const t = (doc?.documentType || '').toLowerCase();
                const n = (doc?.name || '').toLowerCase();
                return (t === 'payslip' || t === 'payroll' || n.includes('payslip')) && doc.meta;
            }).length;
        });
        function getAppConfig() {
            const origHeaders = getHttpInstance().defaults.headers.common;
            getHttpInstance().defaults.headers.common = null;
            getHttpInstance().get("https://s3.eu-west-2.amazonaws.com/config.moneyguided.com/" + state.configUri + "_config.json")
                .then((result) => {
                state.config = result.data;
            })
                .catch(() => { });
            getHttpInstance().defaults.headers.common = origHeaders;
        }
        function getNotifications() {
            api.GET("/Customers/00000000-0000-0000-0000-000000000000/Notifications", (result) => {
                state.notifications = result;
            }, true);
        }
        function getPoints() {
            api.GET("/Customers/00000000-0000-0000-0000-000000000000/Achievements/Points", (result) => {
                state.points = result;
            }, false);
        }
        function checkAndRequestNotifications() {
            const asked = localStorage.getItem("notificationsRequested");
            if (!asked) {
                api.signalV1("enableNotifications", "", "", "", "you");
                localStorage.setItem("notificationsRequested", "true");
            }
        }
        function peekingDrawerBottom() {
            const c = cookies?.get('sb');
            let ret = 44;
            if (c) {
                ret += parseInt(c);
            }
            return ret + 'px';
        }
        function openWhatsAppDrawer() {
            if (whatsAppEnableDrawer.value) {
                whatsAppEnableDrawer.value.openDrawer();
            }
        }
        function handleEnableWhatsApp() {
            const request = {
                title: "welcome_to_mg",
                whatsApp: true,
                whatsAppTemplate: true,
                phoneNumber: state.customer.person.mobilePhone
            };
            getHttpInstance().post(getApiConfig().api + "/Customers/00000000-0000-0000-0000-000000000000/Notifications", request)
                .then(() => { })
                .catch((result) => {
                if (result.response && result.response.status == 401) {
                    api.refreshLogin(() => handleEnableWhatsApp());
                }
            });
        }
        function handleWhatsAppEnableDone() {
            getCustomer(null, false);
        }
        function handleWhatsAppDrawerClosed() {
            // no-op — promo card not used on this page
        }
        function loadCustomer() {
            getAppConfig();
            getCustomer(() => {
                getPoints();
                getNotifications();
                getEmployer(state.customer.employerID);
                getLatestFinancialFitness();
                getProducts(state.customer.employerID);
                getProducts();
                getBlueLightCard((blc) => {
                    blueLight.value = blc;
                });
                getDocuments(() => { });
            });
            checkAndRequestNotifications();
        }
        onMounted(() => {
            loadCustomer();
        });
        return (_ctx, _cache) => {
            const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader");
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, { title: "You" }),
                (!_unref(state).customer)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (n) => {
                            return _createVNode(_component_v_skeleton_loader, {
                                type: "list-item-avatar-two-line",
                                key: n,
                                class: "you-skeleton-item"
                            });
                        }), 64))
                    ]))
                    : _createCommentVNode("", true),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (_unref(state).customer)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _createVNode(_component_v_row, null, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_col, null, {
                                            default: _withCtx(() => [
                                                _createVNode(MGMInfoPanel)
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                }),
                                (!_unref(state).customer.person.whatsAppEnabled)
                                    ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_col, null, {
                                                default: _withCtx(() => [
                                                    _createVNode(AdButton, {
                                                        title: "Whatsapp",
                                                        onClick: openWhatsAppDrawer,
                                                        subtitle: "Enable Whatsapp to chat with us about your finances & send in your documents for automatic processing!",
                                                        topicon: require('@/assets/Whatsapp.webp'),
                                                        bottomrighticon: require('@/assets/go.png')
                                                    }, null, 8, ["topicon", "bottomrighticon"])
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    }))
                                    : _createCommentVNode("", true),
                                _createVNode(_Transition, null, {
                                    default: _withCtx(() => [
                                        (_unref(state).points && showPoints.value)
                                            ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_col, null, {
                                                        default: _withCtx(() => [
                                                            _createVNode(InfoPanel, {
                                                                href: "/#/Points",
                                                                valueHref: "/#/Leaderboard",
                                                                icon: require('@/assets/points.png'),
                                                                title: "MG Points",
                                                                subtitle: "Use the app to earn MG Points",
                                                                valueTitle: "Points",
                                                                value: _unref(state).points.points
                                                            }, null, 8, ["icon", "value"])
                                                        ]),
                                                        _: 1
                                                    })
                                                ]),
                                                _: 1
                                            }))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_Transition, null, {
                                    default: _withCtx(() => [
                                        (_unref(state).financialFitness)
                                            ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_col, null, {
                                                        default: _withCtx(() => [
                                                            _createVNode(InfoPanel, {
                                                                href: "/#/FinancialFitness",
                                                                valueHref: "/#/FinancialFitnessHistory",
                                                                icon: require('@/assets/financialFitnessIcon.png'),
                                                                title: "My Financial Fitness",
                                                                subtitle: "Take the survey",
                                                                valueTitle: "Score",
                                                                value: _unref(state).financialFitness.score
                                                            }, null, 8, ["icon", "value"])
                                                        ]),
                                                        _: 1
                                                    })
                                                ]),
                                                _: 1
                                            }))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_Transition, null, {
                                    default: _withCtx(() => [
                                        (!_unref(state).financialFitness)
                                            ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_col, null, {
                                                        default: _withCtx(() => [
                                                            _createVNode(InfoPanel, {
                                                                href: "/#/FinancialFitness",
                                                                valueHref: "/#/FinancialFitness",
                                                                icon: require('@/assets/financialFitnessIcon.png'),
                                                                title: "My Financial Fitness",
                                                                subtitle: "Let's calculate your baseline",
                                                                valueTitle: "Score",
                                                                value: "-"
                                                            }, null, 8, ["icon"])
                                                        ]),
                                                        _: 1
                                                    })
                                                ]),
                                                _: 1
                                            }))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_Transition, null, {
                                    default: _withCtx(() => [
                                        (_unref(state).documents)
                                            ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_col, null, {
                                                        default: _withCtx(() => [
                                                            _createVNode(DocumentsInfoPanel, {
                                                                documentCount: _unref(state).documents.length,
                                                                categoryCount: documentCategoryCount.value
                                                            }, null, 8, ["documentCount", "categoryCount"])
                                                        ]),
                                                        _: 1
                                                    })
                                                ]),
                                                _: 1
                                            }))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_Transition, null, {
                                    default: _withCtx(() => [
                                        (_unref(state).documents && _unref(showPayslips))
                                            ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_col, null, {
                                                        default: _withCtx(() => [
                                                            _createVNode(DocumentsInfoPanel, {
                                                                variant: "payslips",
                                                                documentCount: payslipCount.value
                                                            }, null, 8, ["documentCount"])
                                                        ]),
                                                        _: 1
                                                    })
                                                ]),
                                                _: 1
                                            }))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_Transition, null, {
                                    default: _withCtx(() => [
                                        (_unref(state).customer)
                                            ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_col, null, {
                                                        default: _withCtx(() => [
                                                            _createVNode(AdButton, {
                                                                title: "Switch",
                                                                href: 'https://moneyguided.aptap.co.uk?p1=' + _unref(state).customer.person.email + '&p2=' + (_unref(state).customer.person.addresses.length > 0 ? _unref(state).customer.person.addresses[0].postCode : ''),
                                                                subtitle: "Move to a better Broadband, SIM, Mobile or Energy deal",
                                                                topicon: require('@/assets/switch.png'),
                                                                bottomrighticon: require('@/assets/go.png')
                                                            }, null, 8, ["href", "topicon", "bottomrighticon"])
                                                        ]),
                                                        _: 1
                                                    })
                                                ]),
                                                _: 1
                                            }))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_Transition, null, {
                                    default: _withCtx(() => [
                                        (_unref(state).benefits && _unref(state).benefits.length > 0)
                                            ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_col, null, {
                                                        default: _withCtx(() => [
                                                            _createVNode(ScrollThumbBlock, {
                                                                href: "/#/Benefits",
                                                                title: _unref(state).employer ? _unref(state).employer.name + ' Benefits' : 'Employee Benefits',
                                                                subtitle: "View your employee benefits",
                                                                thumbs: _unref(state).benefits,
                                                                rightimage: require('@/assets/arrow-right.png')
                                                            }, null, 8, ["title", "thumbs", "rightimage"])
                                                        ]),
                                                        _: 1
                                                    })
                                                ]),
                                                _: 1
                                            }))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_Transition, null, {
                                    default: _withCtx(() => [
                                        (_unref(state).marketplace)
                                            ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_col, null, {
                                                        default: _withCtx(() => [
                                                            _createVNode(ScrollThumbBlock, {
                                                                href: "/#/Marketplace",
                                                                title: "Marketplace",
                                                                subtitle: "Explorer deals with our partners",
                                                                thumbs: _unref(state).marketplace,
                                                                rightimage: require('@/assets/arrow-right.png')
                                                            }, null, 8, ["thumbs", "rightimage"])
                                                        ]),
                                                        _: 1
                                                    })
                                                ]),
                                                _: 1
                                            }))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_v_row, null, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_col, null, {
                                            default: _withCtx(() => [
                                                _createVNode(AdButton, {
                                                    href: "/#/CompletedMoves",
                                                    topicon: require('@/assets/bullet-tick.png'),
                                                    bottomrighticon: require('@/assets/go.png'),
                                                    subtitle: "Review all your completed Moves",
                                                    title: "Completed Moves"
                                                }, null, 8, ["topicon", "bottomrighticon"])
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_v_row, null, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_col, null, {
                                            default: _withCtx(() => [
                                                _createVNode(AdButton, {
                                                    href: "/#/allnotifications",
                                                    topicon: require('@/assets/bell.svg'),
                                                    bottomrighticon: require('@/assets/go.png'),
                                                    subtitle: "Review your notifications",
                                                    title: "Notifications"
                                                }, null, 8, ["topicon", "bottomrighticon"])
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                })
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                (blueLight.value)
                    ? (_openBlock(), _createBlock(DrawerPanel, {
                        key: 1,
                        ref: "blcDrawer",
                        bottom: peekingDrawerBottom(),
                        title: "Blue Light Card",
                        backgroundColor: "white",
                        openBackgroundColor: "white"
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("img", {
                                style: { "width": "100%" },
                                src: blueLight.value.url
                            }, null, 8, _hoisted_3)
                        ]),
                        _: 1
                    }, 8, ["bottom"]))
                    : _createCommentVNode("", true),
                (blueLight.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4))
                    : _createCommentVNode("", true),
                _createVNode(WhatsAppEnableDrawer, {
                    ref_key: "whatsAppEnableDrawer",
                    ref: whatsAppEnableDrawer,
                    phoneNumber: _unref(state).customer?.person?.mobilePhone || '',
                    onEnable: handleEnableWhatsApp,
                    onDone: handleWhatsAppEnableDone,
                    onClosed: handleWhatsAppDrawerClosed
                }, null, 8, ["phoneNumber"])
            ], 64));
        };
    }
});
